<template>
  <cy-drawer :title="$t('添加/编辑')" v-model="visible" :loading="loading" @cancel="cancel" @confirm="submit('form')">
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-row :gutter="10">
        <a-col
          :lg="12"
        ><a-form-model-item
          :label="$t('设备名称')"
          prop="devName"
        ><a-input v-model="form.devName" :placeholder="$t('请输入')" :maxLength="50"></a-input></a-form-model-item
        ></a-col>
        <a-col
          :lg="12"
        ><a-form-model-item
          :label="$t('设备编号')"
          prop="devCode"
        ><a-input v-model="form.devCode" :placeholder="$t('请输入')"></a-input></a-form-model-item
        ></a-col>
        <a-col
          :lg="12"
        ><a-form-model-item
          :label="$t('备注')"
          prop="remark"
        ><a-input v-model="form.remark" :placeholder="$t('请输入')" :maxLength="255"></a-input></a-form-model-item
        ></a-col>
        <a-col
          :lg="12"
        ><a-form-model-item
          :label="$t('设备封面图')"
          prop="devImg"
        >
          <file-upload ref="upload" @change="uploadChange"></file-upload>
        </a-form-model-item
        ></a-col>

      </a-row>
    </a-form-model>
  </cy-drawer>
</template>
<script>
import CyDrawer from '@/components/CyDarwer'
import FileUpload from '@/components/FileUpload/index2'
import { mapGetters } from 'vuex'
import { addObj, putObj, getObj } from '../api'
export default {
  // 组件名称
  name: 'CreateForm',
  // 过滤器
  filters: {},
  // 组件
  components: {
    CyDrawer,
    FileUpload
  },
  // props类型
  props: {
    model: {
      type: Object,
      default: () => null
    }
  },
  // 数据

  data() {
    return {
      visible: false,
      loading: false,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      URL: process.env.VUE_APP_API_BASE_URL + '/api/common/upload',
      baseurl: process.env.VUE_APP_API_BASE_URL,
      imgList: [],
      form: {
        devCode: undefined,
        devImg: undefined,
        devName: undefined,
        id: undefined,
        remark: undefined,
        userId: undefined
      },
      rules: {
        devCode: [
          { required: true, message: this.$t('只能输入字母或数字'), pattern: /^\w+/ }
        ],
        devImg: [
          { required: true, message: this.$t('请选择') }
        ],
        devName: [
          { required: true, message: this.$t('请输入') }
        ],
        id: [
          { required: true, message: this.$t('请输入') }
        ],
        remark: [
          { required: false, message: this.$t('请输入') }
        ],
        userId: [
          { required: true, message: this.$t('请输入') }
        ]
      },
      editFlag: true,
      select: {
        provinceId: null,
        cityId: null,
        areaId: null
      },
      typeList: []
    }
  },
  // 计算属性
  computed: {
    ...mapGetters(['roleList'])
  },
  // 计算属性监听
  watch: {},
  // 创建时
  created() {},
  // 挂载完毕
  mounted() {},
  // 方法
  methods: {
    uploadChange(e) {
      this.form.devImg = e ? e.url : undefined
    },
    editorChange(e) {
      console.log(e)
      if (e === '<p><br></p>') {
        this.form.content = ''
      } else {
        this.form.content = e
      }
    },
    handleUploadChange(values) {
      console.log(values)
      this.form.iamTypeNum = values.length > 1 ? 2 : 1
      this.form.iamgePaths = values.map((item) => item.shortcutUrl).join(',')
    },
    del(index) {
      this.form.propDrops.splice(index, 1)
    },
    addDomain() {
      const obj = {
        propNum: undefined,
        num: 0,
        infeRate: 0
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.propDrops.push(JSON.parse(JSON.stringify(obj)))
        }
      })
    },
    init(id) {
      if (id) this.form.id = id
      this.visible = true
      this.$nextTick(() => {
        console.log(this.$refs)

        if (id) {
          getObj(this.form.id).then((res) => {
            this.form = res.data
            this.$refs.upload.init(this.form.devImg ? {
              fileExplainName: this.form.devImg,
              filePath: this.form.devImg,
              fileId: this.form.id
            } : '', 200, 200)
          })
        } else {
          this.$refs.upload.init('', 200, 200)
        }
      })
    },
    cancel() {
      this.visible = false
      this.$emit('close')
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          if (this.form.id) {
            putObj({ ...this.form })
              .then((res) => {
                this.cancel()
                this.$emit('refresh')
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            addObj({ ...this.form })
              .then((res) => {
                this.cancel()
                this.$emit('refresh')
              })
              .catch(() => {
                this.loading = false
              })
          }
        }
      })
    },
    handlecoverPicList(e) {
      console.log(e)
      if (e.length > 0) {
        this.form.avatar = e[0].url
      }
    },
    change() {},
    selected(e) {
      console.log(e)
      this.form.province = e.province.value
      this.form.city = e.city.value
      this.form.area = e.area.value
    }
  }
}
</script>

<style lang="less" scoped>
.amap-demo {
  height: 300px;
}

.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}
.daoju {
  position: relative;
  .del {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
